module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAA0ElEQVRIx2Pw89X9f0rE5P8lgcGJGRiKNP8rJ2n/X69gNHgdCMIceZr/m00NBq8DYXiwRTmGA+FRrmg0eB0Ii/KmQRDlOB0Iwx4lnq9uVnWceFbVd2wgMEEHgrBmp/f/K89v/x8IQJQDQZirwvD/vJPrBq8DYThuWcX/Lz+/jTpweEXxoM4kPNEar1S11U+oq6sfGwiM24F56v8ZtAWAPmAYYIzNcfFK/xmE2QeB47A50EPqPwML0yBxHLIDwVHKP4gchuzAQRWl6HjQRSkqBgCbkJcknBjNrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sd.png
// module id = 922
// module chunks = 0